var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFrance = function SvgFrance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 12c0 4.367 2.8 8.067 6.667 9.433V2.567C4.8 3.933 2 7.633 2 12Z",
    fill: "#428BC1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 12a9.967 9.967 0 0 0-6.667-9.433v18.866A9.967 9.967 0 0 0 22 12Z",
    fill: "#ED4C5C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.667 21.433A9.997 9.997 0 0 0 12 22c1.167 0 2.3-.2 3.333-.567V2.567A9.853 9.853 0 0 0 12 2c-1.2 0-2.3.2-3.333.567v18.866Z",
    fill: "#fff"
  })));
};
export default SvgFrance;